import { useEffect } from "react";
import PropTypes from "prop-types";

/** Sends the browser to an external URL (App Store, etc.). */
export default function ExternalRedirect({ href }) {
    useEffect(() => {
        const target = String(href || "").trim();
        if (target) {
            window.location.replace(target);
        }
    }, [href]);

    return null;
}

ExternalRedirect.propTypes = {
    href: PropTypes.string.isRequired,
};
